export default __webpack_public_path__ + "static/media/avatar6.97310bf2.png";